
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"1.8 0.7 21 23.3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.713 6.368V3.774s0-2.24 2.276-2.24h12.338s2.276.117 2.276 2.24v16.863s0 2.476-2.515 2.476H6.348s-2.635.472-2.635-2.594v-2.594M2.396 6.604h2.636M2.396 15.448h2.636M3.715 13.68v1.768","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.994 14.15c-.36.59-1.078.943-1.797.943-1.317 0-2.276-1.061-2.276-2.476 0-2.005 1.438-3.42 2.995-3.42.719 0 1.318.354 1.557.943l.12-.825h1.198l-.838 3.773v.472c0 .354.12.59.599.59.838 0 1.677-1.298 1.677-2.83 0-2.123-1.677-3.774-4.193-3.774-2.635 0-4.672 1.887-4.672 4.717 0 2.594 1.797 4.481 4.792 4.481 1.078 0 2.156-.354 3.114-1.061l.6.825c-1.079.826-2.397 1.297-3.714 1.297-3.474 0-5.99-2.24-5.99-5.66-.12-3.066 2.396-5.66 5.63-5.778h.24c2.995 0 5.39 2.122 5.39 4.835 0 2.24-1.317 3.891-2.874 3.891-.839 0-1.438-.236-1.558-.943zm-1.078-3.892c-1.078 0-1.797 1.062-1.797 2.123 0 .943.36 1.65 1.318 1.65 1.078 0 1.677-1.06 1.797-2.358-.12-.825-.599-1.415-1.318-1.415z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M2.396 11.085h2.636M3.715 9.316v1.769","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    